<template>
  <form @submit.prevent="submit()">
    <div class="form-row">
      <div class="col">
        <input v-model="title"
               type="text"
               class="form-control"
               id="form_title"
               placeholder="title"
               autocomplete="off"
               required>
      </div>
    </div>

    <div class="form-row">
      <div class="col">
        <input v-model="lat" type="text" class="form-control" id="form_lat" placeholder="lat" required>
      </div>
      <div class="col">
        <input v-model="long" type="text" class="form-control" id="form_long" placeholder="long" required>
      </div>
    </div>
    <div class="form-row">
      <div class="col">
        <button type="submit" class="btn btn-primary">Save</button>
      </div>
    </div>

    <hr/>

    <AddMap :lat="lat" :long="long" :zoom="13" v-on:updatePosition="updatePosition"></AddMap>
  </form>
</template>

<script>
  import AddMap from "./AddMap";

  export default {
    name: 'AddPlaceForm',
    mounted: function () {

    },
    methods: {
      submit() {
        fetch(window.env.API_URL + '/api/places', {
          method: 'POST',
          mode: 'cors',
          cache: 'no-cache',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json'
          },
          redirect: 'manual',
          referrerPolicy: 'no-referrer',
          body: JSON.stringify({
            title: this.title,
            latitude: this.lat.toString(),
            longitude: this.long.toString()
          })
        })
          .then(res => res.json())
          .then(res => {
            this.$router.push('/')
          });
      },
      updatePosition(e) {
        this.lat = e[0];
        this.long = e[1];
      }
    },
    components: {
      AddMap
    },
    data() {
      return {
        title: null,
        lat: 60.042646439057954,
        long: 30.306429862976078,
      }
    }
  }
</script>